require('./mortgageRequestOperativeParticipants.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const getParticipantsActions = require('actions/mortgageRequest/mortgageRequestDataOperativeParticipants');


class MortgageRequestOperativeParticipants extends React.Component {
    constructor(props){
        super(props)
        this.setParticipants = this.setParticipants.bind(this);
    }

    componentWillMount(){
        const { requestDataOperativeParticipants, contractNumber, product } = this.props;
        requestDataOperativeParticipants(contractNumber, product);
    }

    setParticipants(data){
        if (data.get('load')){
            const participants = data.get('participantsList');
            const lengthList = participants.size;
            const column = participants.map(participant => {
                const typeParticipant = participant.get('tipoIntervencion');
                const nameParticipant = participant.get('nombreInterviniente');
                const handlerClass = lengthList <= 1 ? 'col-md-12' : 'col-md-6';

                return (
                    <div key={nameParticipant} className="row">
                        <div className={handlerClass}>
                            <h5
                                className="mortgage-request-operative-participants__colum-text mortgage-request-operative-participants--transform-text-capital-first"
                            >
                                {typeParticipant}
                            </h5>
                            <p
                                className="mortgage-request-operative-participants__data mortgage-request-operative-participants--transform-text-capital-first"
                            >
                                {nameParticipant}
                            </p>
                        </div>
                    </div>
                );
            });
            return column
        } else {
            return <LoadingSection />
        }
    }
    render(){
        const listParticipants = this.setParticipants(this.props.mortgageRequestDataParticipantsState);
        return (
            <div className="mortgage-request-operative-participants">
                <h1 className="mortgage-request-operative-participants__title">
                    {formatText('morgageRequestOpertativeParticipants-title')}
                </h1>
                {listParticipants}
            </div>
        );
    }
}

MortgageRequestOperativeParticipants.propTypes = {
    contractNumber: PropTypes.string.isRequired,
    mortgageRequestDataParticipantsState: PropTypes.object,
    product: PropTypes.string.isRequired,
    requestDataOperativeParticipants: PropTypes.func,
    setParticipants: PropTypes.func
}

MortgageRequestOperativeParticipants.defaultProps = {
    product: '',
    contractNumber: '',
};

module.exports.constructor = MortgageRequestOperativeParticipants;

module.exports.MortgageRequestOperativeParticipants = connect(
    state =>({
        mortgageRequestDataParticipantsState: state.mortgageRequestDataParticipants
    }), {
        requestDataOperativeParticipants: getParticipantsActions.requestDataOperativeParticipants
    })(MortgageRequestOperativeParticipants);